import __request__ from 'routing/request';
interface SingleSubsystemSummary {
    readonly level_syslog: number;
    readonly level: string;
    readonly description: string;
    readonly categories: string[];
    readonly title: string;
}
interface SubsystemSummaryMap {
    readonly [_key: string]: SubsystemSummary;
}
interface LoggersSummaryMap {
    readonly [_key: string]: LoggersSummary;
}
interface SubsystemSummary {
    readonly subsystems: {
        readonly [_key: string]: SingleSubsystemSummary;
    };
}
interface SingleLoggerSummary {
    readonly level_syslog: number;
    readonly level: string;
}
interface LoggersSummary {
    readonly total: number;
    readonly loggers: {
        readonly [_key: string]: SingleLoggerSummary;
    };
}
interface CallResult_VoidMap {
    readonly [_key: string]: CallResult_Void;
}
interface CallResult_Void {
    readonly response: void;
    readonly server_error_message: string;
    readonly call_executed: boolean;
}
/**
 * List all loggers of all nodes and their current levels
 */
export function loggers(): Promise<LoggersSummaryMap> {
    return __request__('GET', '/cluster/system/loggers', null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Get recent internal log messages from a specific node
 * @param nodeId The nodeId to get logs from
 * @param limit How many log messages should be returned. 0 returns all existing messages.The limit can be rounded up to the next batch size and thus return slightly more logs than requested.
 */
export function messages(nodeId?: string, limit: number = 1000): Promise<unknown> {
    return __request__('GET', `/cluster/system/loggers/messages/recent/${nodeId}`, null, { 'limit': limit }, {
        'Accept': ['text/plain']
    });
}
/**
 * List all logger subsystems and their current levels
 */
export function subsystems(): Promise<SubsystemSummaryMap> {
    return __request__('GET', '/cluster/system/loggers/subsystems', null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Set the loglevel of a single logger
 */
export function setClusterSingleLoggerLevel(loggerName: string, level: string): Promise<CallResult_VoidMap> {
    return __request__('PUT', `/cluster/system/loggers/${loggerName}/level/${level}`, null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Set the loglevel of a whole subsystem
 */
export function setSubsystemLoggerLevel(nodeId: string, subsystem: string, level: string): Promise<void> {
    return __request__('PUT', `/cluster/system/loggers/${nodeId}/subsystems/${subsystem}/level/${level}`, null, {}, {
        'Accept': []
    });
}
